import { UserSettings } from "./userSettings";

const Settings = () => {
    return (
        <div>
            <h1 className="text-left text-nt-blue mb-8">User settings</h1>
            <UserSettings />
        </div>

    )
}

export { Settings };